type Task = (...any: any[]) => Promise<void>;
const TASK_QUEUE: Record<string, [Task, any][]> = {};

async function runTask(key: string) {
  if (!TASK_QUEUE[key]) {
    return;
  }

  if (!TASK_QUEUE[key].length) {
    delete TASK_QUEUE[key];
    return;
  }

  const [task, args] = TASK_QUEUE[key].shift()!;
  Array.isArray(args) ? await task(...args) : await task(args);

  TASK_QUEUE[key].length ? runTask(key) : delete TASK_QUEUE[key];
}

export function queueTask(args: { key: string; task: Task; args: any; }) {
  if (TASK_QUEUE[args.key]) {
    TASK_QUEUE[args.key].push([args.task, args.args]);
    return;
  }

  TASK_QUEUE[args.key] = [[args.task, args.args]];
  runTask(args.key);
}
